<div class="header-row">
  <a id="cart-link" class="d-none d-lg-inline-block {{cartService.CartItemCount == 0 ? 'empty' : ''}}" routerLink="cart"
    aria-label="Shopping Cart / Checkout">

    <fa-layers size="2x" class="mr-4">
      <fa-icon icon="shopping-cart"></fa-icon>
      <fa-layers-counter *ngIf="!cartService.PendingUpdate" content="{{cartService.CartItemCount}}"></fa-layers-counter>
      <fa-icon *ngIf="cartService.PendingUpdate" icon="spinner" [spin]="true"></fa-icon>
    </fa-layers>
  </a>
  <div ngbDropdown display="static" class="d-inline-block">
    <button class="btn btn-success d-none d-md-inline-block" id="drpMyAccount"
      ngbDropdownToggle>{{user.Name.possessive}} Account</button>
    <button class="btn btn-success btn-sm d-inline-block d-md-none" id="drpMyAccount" ngbDropdownToggle>
      <fa-icon class="m-2" icon="user" size="md"></fa-icon>
    </button>
    <div ngbDropdownMenu aria-labelledby="drpMyAccount">
      <a class="text-primary" ngbDropdownItem routerLink="myaccount">My Account</a>
      <a class="text-primary" ngbDropdownItem routerLink="transcript">My CE Transcript</a>
      <a class="text-primary" ngbDropdownItem href="{{baseURL}}members" target="_blank">Go to ABMP.com</a>
      <a class="text-secondary" ngbDropdownItem href="#logout" (click)="Logout();">Log out</a>
    </div>
  </div>
</div>
